// all fields for new submission form
import submissionsFormEntities from './submissionsFormEntities';
import monthlyRevenueValues from './monthlyRevenueValues';
import loanUseValues from './loanUseValues';
import usaStates from './usaStates';
import {
  ACCOUNT_FIELDS,
  ADDRESS_FIELDS,
  APPLICATION_FIELDS,
  CONTACT_FIELDS
} from './serverFieldMappings';
import { BUSINESS_INFO_GOOGLE_AUTOCOMPLETE, OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE } from './googleAPI';
import {
  validateZipLength,
  validatePhoneLength,
  validateEmail,
  validateOwnership
} from '../api/submissionApiUtils';
import { ZIP_LENGTH_MESSAGE, PHONE_LENGTH_MESSAGE } from './fieldsConstants';
import { LOOKUP_DESCRIPTION } from './fieldsConstants';

const emailValidationObj = () => {
  return {
    validationErrors: {
      format: "Email doesn't seem correct "
    },
    validationFunctions: {
      format: validateEmail
    }
  };
};

const ownership = (index=0) => {
  if (index === 0 || index === 1) {
    const modelVal = `OWNERINFOPERCENT_${index + 1}`;
    return [{
      modelVal: `${APPLICATION_FIELDS[modelVal]}`,
      display: '% Ownership',
      inputType: 'text',
      required: false,
      placeHolder: '',
      suffix: '%',
      maxLength: 3,
      className: 'ownership-box',
      validations: {
        validationErrors: {ownership: "Ownership % must between 1 and 100"},
        validationFunctions: {ownership: validateOwnership}
      },
      useMask: true
    }];
  } else {
    return [];
  }
};

const address = ({attributePrefix=""}) => {
  return [
    {modelVal: `${attributePrefix}${ADDRESS_FIELDS.STREET_1}`, display: 'Street Address', inputType: 'text', required: true, useMask: false, placeHolder: ''},
    {modelVal: `${attributePrefix}${ADDRESS_FIELDS.STREET_2}`, display: 'Street Address 2', inputType: 'text', required: false, useMask: false, placeHolder: ''},
    {modelVal: `${attributePrefix}${ADDRESS_FIELDS.CITY}`, display: 'City', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 40},
    {modelVal: `${attributePrefix}${ADDRESS_FIELDS.STATE}`, display: 'State', inputType: 'dropdown', options: usaStates, required: true, useMask: false, placeHolder: ''},
    {modelVal: `${attributePrefix}${ADDRESS_FIELDS.ZIP}`, display: 'Zip Code', inputType: 'text', required: true, useMask: true, placeHolder: '', maxLength: 10, validateLength: validateZipLength, lengthMessage: ZIP_LENGTH_MESSAGE, className: "small-text"},
  ];
};

const ownerFieldByIndex = (index=0) => {
  const attributePrefix = `owners[${index}].`;
  return [
    {modelVal: `${attributePrefix}close_button`, index: index, inputType: 'closeButton'},
    {modelVal: `${attributePrefix}subtitle`, display: `Owner ${index + 1}`, inputType: 'subtitle'},
    ...ownership(index),
    {modelVal: `${attributePrefix}${CONTACT_FIELDS.NAME_1}`, display: 'First Name', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 40},
    {modelVal: `${attributePrefix}${CONTACT_FIELDS.NAME_2}`, display: 'Last Name', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 80},
    {modelVal: `${attributePrefix}${OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE.MODEL}`, ownerIndex: index, display: "Find your client's street address in Google Places to prepopulate the address fields.", inputType: 'addressSearch', required: false, useMask: false, placeHolder: "Type to search", labels: OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE.LABELS, classForLabel: 'submission-form-lookup'},
    ...address({attributePrefix}),
    {modelVal: `${attributePrefix}${CONTACT_FIELDS.UNIQUE_ID}`, display: 'SSN', inputType: 'text', required: true, useMask: true, placeHolder: '00-00-0000', className: 'small-text'},
    {modelVal: `${attributePrefix}${CONTACT_FIELDS.START_DATE}`, display: 'DOB', inputType: 'datepicker', required: true, useMask: false, placeHolder: '', className: "small-text"},
    {modelVal: `${attributePrefix}home_phone`, display: 'Home Phone', inputType: 'text', required: false, useMask: true, placeHolder: '', validateLength: validatePhoneLength, lengthMessage: PHONE_LENGTH_MESSAGE, className: "small-text"},
    {modelVal: `${attributePrefix}cell_phone`, display: 'Cell Phone', inputType: 'text', required: false, useMask: true, placeHolder: '', validateLength: validatePhoneLength, lengthMessage: PHONE_LENGTH_MESSAGE, className: "small-text"},
    {modelVal: `${attributePrefix}${CONTACT_FIELDS.EMAIL}`, display: 'Email', inputType: 'text', required: false, useMask: true, placeHolder: '', maxLength: 80, validations: emailValidationObj()}
  ];
};

export default (industries=[]) => ({
  section1: [
    {modelVal: BUSINESS_INFO_GOOGLE_AUTOCOMPLETE.MODEL, display:'Complete the form faster with Google Places Lookup!', inputType: 'addressSearch', required: false, useMask: false, labels: BUSINESS_INFO_GOOGLE_AUTOCOMPLETE.LABELS, placeHolder: "Type to search", additionInfo: LOOKUP_DESCRIPTION, classForLabel: 'submission-form-lookup'},
    {modelVal: ACCOUNT_FIELDS.NAME_1, display: 'Business DBA', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 80},
    {modelVal: ACCOUNT_FIELDS.NAME_2, display:'Business Legal Name', inputType: 'businessLegal', required: true, useMask: false, placeHolder: '', maxLength: 80, otherVal: 'sameDbaAndLegalName'},
    {modelVal: APPLICATION_FIELDS.CAPITAL_NEEDED, display:'Requested Amount', inputType: 'dollar', required: false, placeHolder: '', maxLength: 10, needsInstruction: true},
    {modelVal: APPLICATION_FIELDS.APPLICANT_IS_OWNER, display:'Is the Applicant an Owner?', inputType: 'radio', options: ["yes", "no"], required: true, useMask: false, placeHolder: ''},
    {modelVal: APPLICATION_FIELDS.LOAN_USE, display:'Use and Impact of Funds', inputType: 'dropdown', options: loanUseValues, required: false, useMask: false, placeHolder: ''},
  ],
  section2: [
    {display: 'Business Information', inputType: 'title', required: false, useMask: false, placeHolder: ''},
    ...address({}),
    {modelVal: ACCOUNT_FIELDS.PHONE_1, display: 'Phone', inputType: 'text', required: true, useMask: true, placeHolder: '', validateLength: validatePhoneLength, lengthMessage: PHONE_LENGTH_MESSAGE, className: 'small-text'},
    {modelVal: ACCOUNT_FIELDS.WEBSITE, display: 'Website', inputType: 'text', required: false, useMask: false, placeHolder: ''},
    {modelVal: ACCOUNT_FIELDS.EMAIL, display: 'Email', inputType: 'text', required: false, useMask: true, placeHolder: '', maxLength: 80, validations: emailValidationObj()},
    {modelVal: ACCOUNT_FIELDS.TYPE, display: 'Entity Type', inputType: 'dropdown', options: submissionsFormEntities, required: true, useMask: false, placeHolder: ''},
    {modelVal: ACCOUNT_FIELDS.START_DATE, display: 'Business Start Date', inputType: 'datepicker', required: true, useMask: false, placeHolder: '', className: "small-text"},
    {modelVal: ACCOUNT_FIELDS.REVENUE, display: 'Monthly Revenue', inputType: 'dropdown', options: monthlyRevenueValues, required: false, useMask: false, placeHolder: ''},
    {modelVal: ACCOUNT_FIELDS.INDUSTRY_NAME, display: 'Industry', inputType: 'dropdown', options: industries, required: true, useMask: false, placeHolder: ''},
    {modelVal: ACCOUNT_FIELDS.UNIQUE_ID, display: 'Federal Tax ID', inputType: 'text', required: false, useMask: true, placeHolder: '00-0000000', className: "small-text"},
    {display: 'Owner Information', inputType: 'title', required: false, useMask: false, placeHolder: ''},
    {inputType: 'removeOwnerModal', modalActive: false}
  ],
  addOwnerButton: {modelVal: 'add_owner_button', inputType: 'addOwnerButton'},
  ownerInfo: ownerFieldByIndex,
  section3: [
    {display: 'Financing Information', inputType: 'title', required: false, useMask: false, placeHolder: ''},
    {modelVal: APPLICATION_FIELDS.NOTES, display: 'Additional Notes For Underwriter', inputType: 'textarea', required: false, useMask: false, placeHolder: 'Include any additional information here that would help the underwriter review the file and give the most competitive approval.'},
    {modelVal: APPLICATION_FIELDS.HAS_CURRENT_LOAN, display: 'Existing Financing?', inputType: 'existingFinancing', required: false, useMask: false, placeHolder: ''},
  ],
  section4: [
    {modelVal: 'uploadDocuments', display: 'Upload Documents', inputType: 'file', required: true},
  ]
});
